"use client";

import { Box as MantineBox, Pill, Tooltip } from "@mantine/core";
import styles from "./tag.module.scss";

const TRUNCATE_THRESHOLD = 28;

type Props = {
  onClick: (option: Filter | FilterOption, dropdown?: string) => void;
  item: {
    dropdown: string;
    option: Filter | FilterOption;
  };
};
const Tag = ({ onClick, item }: Props) => {
  if (item?.dropdown === "continents") {
    return null;
  }

  const label = item?.option?.label ?? "";
  const isTruncated = label.length > TRUNCATE_THRESHOLD;
  const displayLabel = isTruncated ? `${label.slice(0, TRUNCATE_THRESHOLD)}…` : label;

  const handleOnClick = () => {
    onClick(item.option, item.dropdown);
  };

  const pill = (
    <Pill
      className={styles.filterButtonBox}
      data-state={item?.option?.state ?? null}
      withRemoveButton={true}
      removeButtonProps={{
        onClick: (e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          handleOnClick();
        },
      }}
    >
      <MantineBox component="span">
        <MantineBox component="span">{displayLabel}</MantineBox>
        {item?.option?.size ? ` - ${item.option.size}` : ""}
        {label === "price" ? (
          <MantineBox component="span">
            {(item?.option?.value as string)
              ?.split(",")
              .map((v) => (v === "Infinity" ? "Max" : v))
              .join(" to ")}
          </MantineBox>
        ) : (
          ""
        )}
      </MantineBox>
    </Pill>
  );

  if (isTruncated) {
    return (
      <Tooltip label={label} withArrow>
        {pill}
      </Tooltip>
    );
  }

  return pill;
};

export default Tag;
